export const msalConfig = {
  auth: {
    clientId: process.env.REACT_APP_AUTH_CLIENT_ID,
    authority: process.env.REACT_APP_AUTH_AUTHORITY,// This is a URL (e.g. https://login.microsoftonline.com/{your tenant ID})
    redirectUri: process.env.REACT_APP_AUTH_REDIRECT,
  },
  cache: {
    cacheLocation: "sessionStorage", // This configures where your cache will be stored
    storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
  }
};

    // Add scopes here for ID token to be used at Microsoft identity platform endpoints.
    export const loginRequest = {
      scopes: ["User.Read", "User.ReadBasic.All"]
     };
     
     // Add the endpoints here for Microsoft Graph API services you'd like to use.
     export const graphConfig = {
      graphMeEndpoint: "https://graph.microsoft.com/v1.0/me"
  };

  export const authConfig ={
    //Sharepoint Base URL
    SITE_NAME:'gisconnect.sharepoint.com',
    //SharePoint Site (can be communication/teams)
    RELATIVE_PATH:'sites/JourneyStudentTempFolders'   
    }

 